import "./ScheduleSection.scss";

type ScheduleItem = {
  time: string;
  event: string;
};

const scheduleItems: ScheduleItem[] = [
  {
    time: "14:00",
    event: "Etyeki Sarlós Boldogasszony-templom – Gyülekező",
  },
  {
    time: "14:30",
    event: "Templomi szertartás",
  },
  {
    time: "15:30",
    event: "Etyeki Czímeres Pálinkaház – Vendégvárás",
  },
  {
    time: "16:00",
    event: "Polgári szertartás",
  },
  {
    time: "16:30",
    event: "Gratuláció, közös fotók és koccintás",
  },
  {
    time: "19:30",
    event: "Vacsora",
  },
  {
    time: "21:30",
    event: "Nyitótánc",
  },
  {
    time: "22:30",
    event: "Torta",
  },
  {
    time: "00:00",
    event: "Menyecsketánc és éjféli menü",
  },
  {
    time: "00:30",
    event: "Buli hajnalig",
  },
  {
    time: "01:15",
    event: "Éjszakai transzfer indulása Etyeken belül és a környékre",
  },
];

export const ScheduleSection = () => {
  return (
    <section id="schedule" className="schedule-section">
      <div className="schedule-card">
        <div className="schedule-header">
          <span className="schedule-eyebrow">2026. augusztus 21. (péntek)</span>
          <h2>Menetrend</h2>

          <p>
            Így tervezzük életünk egyik legszebb napját, Veletek együtt.
          </p>
        </div>

        <div className="schedule-notice" role="note">
          <div className="schedule-notice__ornament" aria-hidden="true">
            <span />
            <i />
            <span />
          </div>

          <span className="schedule-notice__title">
            Fontos információ
          </span>

          <p>
            A meghívóban szereplő időponthoz képest {" "}
            <strong>a templomi szertartás egy órával később kezdődik</strong>.
            Kérjük, az alábbi frissített menetrendet tekintsétek irányadónak.
          </p>
        </div>

        <div className="schedule-list">
          {scheduleItems.map((item, index) => (
            <div
              key={`${item.time}-${item.event}`}
              className="schedule-row"
            >
              <div className="schedule-time">{item.time}</div>

              <div className="schedule-marker" aria-hidden="true">
                <span />
              </div>

              <div className="schedule-event">
                <span className="schedule-number">
                  {String(index + 1).padStart(2, "0")}
                </span>

                <p>{item.event}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};